export const BACKEND_API = process.env.BACKEND_API || "http://localhost:3001";
export const BFF_BACKEND = process.env.BFF_BACKEND;
export const ENCRYPTION_SECRET = process.env.ENCRYPTION_SECRET;
export const BASE_PATH = "/bff/plans";
